<template>
  <el-dialog
    title
    :visible.sync="dialogVisible"
    :modal="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="1260px"
    :append-to-body="true"
  >
    <el-container>
      <el-header style="border-bottom:1px solid #eee;">
        <el-row type="flex" align="middle">
          <el-col :span="4" style="font-size:16px">请选择公司</el-col>
          <el-col :span="20">
            <el-autocomplete
              v-model="searchResult"
              :fetch-suggestions="querySearch"
              suffix-icon="el-icon-search"
              size="mini"
              :trigger-on-focus="false"
            >
              <template slot-scope="{ item }">
                <div @click="selectResult(item)">
                  <div style="font-size:16px;color:#000">{{ item.简称 }}</div>
                  <div style="font-size:14px;color:#999999">
                    <span>{{ item.行业 }}</span
                    >/ <span>{{ item.平台等级 | formatPingtai }}</span
                    >/ <span>{{ item.简称 }}</span>
                  </div>
                </div>
              </template>
            </el-autocomplete>
          </el-col>
        </el-row>
      </el-header>
      <el-footer v-if="selectedCompany.length > 0" height="auto" style="border-bottom:1px solid #eee;padding:20px">
        <el-row class="mb10" :gutter="6">
          <el-col :span="2" style="font-size:16px"> <b>已选择:</b> </el-col>
          <el-col :offset="16" :span="3">
            <el-button type="primary" size="mini" style="width:100%" @click="submitData">确定</el-button>
          </el-col>
          <el-col :span="3"> <el-button size="mini" style="width:100%" @click="cancel">取消</el-button> </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-tag
              v-for="item in selectedCompany"
              :key="item._id"
              closable
              size="medium"
              style="cursor:pointer"
              class="mr10 mb10"
              effect="plain"
              @close="removeCompany(item.简称)"
              >{{ item.简称 }}</el-tag
            >
          </el-col>
        </el-row>
      </el-footer>
      <el-container class="mb20" style="padding:20px 0">
        <el-aside style="height:50vh;overflow:scroll" width="220px">
          <el-menu :default-active="curIndustries" @select="selectIndustries">
            <el-menu-item v-for="item in industries" :key="item" :index="item">
              {{ item }}
              <el-badge v-if="industriesNum(item) !== 0" class="mark" :value="industriesNum(item)" />
            </el-menu-item>
          </el-menu>
        </el-aside>
        <el-main>
          <el-radio-group v-model="pingtai" size="small" class="mb10 fz14">
            <el-radio-button label="A">大平台</el-radio-button>
            <el-radio-button label="B">中型平台</el-radio-button>
            <el-radio-button label="C">小平台</el-radio-button>
            <el-radio-button label>未分类公司</el-radio-button>
          </el-radio-group>
          <div class="tag-group">
            <el-tag
              v-for="item in resultCompany"
              :key="item._id"
              size="medium"
              style="cursor:pointer;border:none;font-size:14px;width:160px;display:inline-flex;justify-content:space-between;align-items:center"
              class="mr10 mb10 custom-tags"
              :effect="tagType(item.简称)"
              :closable="tagType(item.简称) === 'dark'"
              @close="removeCompany(item.简称)"
              @click="selectCompany(item)"
              >{{ item.简称 }}</el-tag
            >
            <div v-if="resultCompany.length === 0">暂无相关数据~</div>
          </div>
        </el-main>
      </el-container>
    </el-container>
  </el-dialog>
</template>
<script>
export default {
  filters: {
    formatPingtai(val) {
      const temp = { A: '大平台', B: '中型平台', C: '小平台' }
      return val ? temp[val] : '未分类公司'
    },
  },
  data: function() {
    return {
      dialogVisible: false,
      industries: app.industries || [],
      pingtai: 'A',
      selectedCompany: [],
      companyData: [],
      searchResult: '',
      curIndustries: '',
      resultCompany: [],
    }
  },
  watch: {
    curIndustries(val) {
      this.getCompany()
    },
    pingtai(val) {
      this.getCompany()
    },
    selectedCompany(val) {
      console.log(val)
    },
  },
  mounted() {
    this.loadAllCompany()
  },
  methods: {
    selectResult(item) {
      this.curIndustries = item.行业
      this.pingtai = item.平台等级 || ''
      this.selectedCompany.every(val => item.简称 !== val.简称) && this.selectedCompany.push(item)
    },
    selectIndustries(index) {
      this.curIndustries = index
    },
    async getCompany() {
      const 平台等级 = this.pingtai ? [this.pingtai] : ['', null]
      const query = { query: { 平台等级, 行业: [this.curIndustries] }, paginate: { page: 1, pageSize: 5000 } }
      const { data } = await window.app.service('company').getCompanyList(query)
      this.resultCompany = data
    },
    tagType(name) {
      return this.selectedCompany.some(val => name === val.简称) ? 'dark' : 'plain'
    },
    industriesNum(industries) {
      return this.selectedCompany.filter(val => val.行业 === industries).length
    },
    open(defaultCompanies, onConfirm) {
      this.dialogVisible = true
      if (Array.isArray(defaultCompanies)) {
        this.selectedCompany = this.companyData.filter(v => defaultCompanies.includes(v.简称))
      }
      if (onConfirm) this.onConfirm = onConfirm
    },
    selectCompany(item) {
      this.selectedCompany.every(val => item.简称 !== val.简称)
        ? this.selectedCompany.push(item)
        : (this.selectedCompany = this.selectedCompany.filter(val => item.简称 !== val.简称))
    },
    removeCompany(item) {
      this.selectedCompany = this.selectedCompany.filter(val => item !== val.简称)
    },
    querySearch: async function(queryString, cb) {
      const list = this.companyData
      const results = queryString != null ? list.filter(this.createFilter(queryString)).slice(0, 10) : []
      return cb(results)
    },
    createFilter: function(queryString) {
      return company => company.简称.indexOf(queryString.toLowerCase()) === 0
    },
    loadAllCompany: async function() {
      const list = await app.service('company').getAbbr()
      this.companyData = list.data
    },
    submitData() {
      const submitData = this.selectedCompany.map(val => val.简称)
      if (submitData.length === 0) {
        this.$message({
          message: '请选择至少一家公司',
          type: 'warning',
        })
        return
      }
      this.$emit('confirm', submitData)
      this.onConfirm && this.onConfirm(submitData)
      this.dialogVisible = false
      this.selectedCompany = []
    },
    cancel() {
      this.dialogVisible = false
      this.selectedCompany = []
    },
  },
}
</script>
<style scoped src="../../statistics/css/hunting.css"></style>
<style scoped>
.custom-tags {
  color: #303133;
}
.custom-tags.el-tag--dark {
  color: #fff;
}
.custom-tags.el-tag--dark:hover {
  color: #fff;
}
.custom-tags:hover {
  color: #409eff;
}
</style>
<style>
.fz14 .el-radio-button--small .el-radio-button__inner {
  font-size: 14px !important;
}
</style>
